import React from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import DurationIcon from '../../svgs/duration.svg';
import EnrollmentIcon from '../../svgs/enrollment.svg';
import { SearchProductTileModel } from '../../models/globals';
import { getColorClass, getDurationText, getEnrollmentDateTextForSearchPage } from '../../utilities/ProductUtilities';
import { ProductTileImage } from '../common/ProductTile';
import { SearchAction } from '../../hooks/search/reducers/SearchActions';
import { SearchParamNames } from '../../models/enums';
import { publishProductClickAnalyticsEvent } from '../../services/analytics';

interface SearchResultsProps {
    dispatch: React.Dispatch<SearchAction>;
    productTiles: SearchProductTileModel[];
    visibleProductTiles: SearchProductTileModel[];
}

const SearchResults: React.FC<SearchResultsProps> = ({ dispatch, productTiles, visibleProductTiles }) => {
    return (
        <>
            {visibleProductTiles.map((product, index) => {
                const colorClass = getColorClass(product);

                return (
                    <div data-testid="search-results-tile" key={product.detailPageUrl.url}>
                        <a
                            aria-label={product.titleHTML}
                            className="text-reset"
                            href={product.detailPageUrl.url}
                            onClick={async (event) => {
                                event.preventDefault();
                                try {
                                    await publishProductClickAnalyticsEvent(product, index);
                                } catch (e) {
                                    console.error(e);
                                } finally {
                                    window.location.assign(product.detailPageUrl.url);
                                }
                            }}
                        >
                            <Card className="bg-light-hover flex-row search-results-tile">
                                <Card.Body className="row m-0">
                                    <ProductTileImage
                                        classification={product.classification}
                                        className="align-self-start col-sm-5 px-0 pr-sm-3"
                                        defaultImage={product.defaultImage}
                                        image={product.image}
                                        typeName={product.typeName}
                                    />
                                    <Col className="px-0 pr-sm-3 pt-3 py-sm-0">
                                        <Card.Title
                                            className={colorClass}
                                            dangerouslySetInnerHTML={{ __html: product.titleHTML }}
                                        />
                                        <Card.Text
                                            className="d-none d-sm-block mb-2"
                                            dangerouslySetInnerHTML={{ __html: product.descriptionHTML }}
                                        />
                                        <ListGroup variant="flush">
                                            <ListGroup.Item className="border-0 p-1">
                                                <EnrollmentIcon
                                                    aria-label="enrollment icon"
                                                    className={`${colorClass} align-middle pb-1 pr-1 size-4`}
                                                />
                                                {getEnrollmentDateTextForSearchPage(product)}
                                            </ListGroup.Item>
                                            <ListGroup.Item className="border-0 p-1">
                                                <DurationIcon
                                                    aria-label="duration icon"
                                                    className={`${colorClass} align-middle pb-1 pr-1 size-4`}
                                                />
                                                {getDurationText(product)}
                                            </ListGroup.Item>
                                        </ListGroup>
                                    </Col>
                                </Card.Body>
                            </Card>
                        </a>
                    </div>
                );
            })}
            {visibleProductTiles.length < productTiles.length && (
                <div className="font-weight-light my-3 fs-search-loadmore text-right">
                    <Button
                        variant="link"
                        className="btn-loadmore text-decoration-none text-primary"
                        onClick={() => dispatch({ type: SearchParamNames.Page })}
                    >
                        + Load more
                    </Button>
                    <span className="text-secondary">{` | Showing ${visibleProductTiles.length} / ${productTiles.length}`}</span>
                </div>
            )}
        </>
    );
};

export { SearchResults, SearchResultsProps };
